// extracted by mini-css-extract-plugin
module.exports = {"planBox":"PlanBox_planBox__3w9lp"};